"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.HeroWrap = styled_components_1.default.section `
  gap: 17px;
  align-items: center;
  justify-content: center;

  h1 {
    max-width: 291px;

    @media screen and (min-width: 768px) {
      max-width: 479px;
    }

    @media screen and (min-width: 1000px) {
      max-width: 991px;
    }

    @media screen and (min-width: 1300px) {
      max-width: 1185px;
    }

    @media screen and (min-width: 1690px) {
      max-width: 1321px;
    }

    @media screen and (min-width: 1920px) {
      max-width: 1464px;
    }
  }

  .landing-hero-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;

    .landing-hero-content-left {
      display: flex;
      align-items: flex-start;
      justify-content: center;

      picture.landing-hero-demo {
        padding-top: 9px;
      }

      ul.landing-hero-image-description {
        gap: 8px;
        margin-left: -10px;

        li {
          background-color: #ffffff;
          border-radius: 10px;
          padding: 10px;
          font-family: Inter, sans-serif;
          font-size: 16px;
          font-weight: 500;
          line-height: 19px;
          text-align: left;
          color: #333333;
          width: fit-content;
          text-wrap: wrap;
          white-space: pre;
        }

        li:not(:first-child) {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          min-height: 58px;
        }
      }
    }

    .landing-hero-content-right {
      display: flex;
      flex-direction: column;
      width: fit-content;
      margin: 0 auto;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 11px;

      ul.landing-hero-features {
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        white-space: pre;

        li {
          position: relative;
          background-color: #ffffff;
          color: #7b4ef8;
          border-radius: 14px;
          padding: 12px 12px 12px 69px;
          font-family: Inter, sans-serif;
          font-size: 16px;
          font-weight: 600;
          line-height: 20px;
          text-align: left;
          text-wrap: wrap;

          span {
            display: inline-block;
          }

          img {
            position: absolute;
          }

          &.landing-hero-gear {
            span {
              max-width: 230px;
            }
            img {
              width: 84.63px;
              height: 81.71px;
              top: 16px;
              left: -20px;
            }
          }

          &.landing-hero-bulb {
            span {
              max-width: 220px;
            }

            img {
              width: 56.03px;
              height: 97.47px;
              top: 1px;
              left: 4px;
            }
          }

          &.landing-hero-star {
            span {
              max-width: 202px;
            }

            img {
              width: 82.88px;
              height: 82.29px;
              top: 2px;
              left: -19px;
            }
          }

          &.landing-hero-darts {
            span {
              max-width: 169px;
            }

            img {
              width: 79.96px;
              height: 74.12px;
              top: -2px;
              left: -15px;
            }
          }
        }
      }

      ul.landing-hero-marketplaces {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
        max-width: 300px;

        li {
          &.google-play img {
            width: 116.95px;
            height: 34.65px;
          }

          &.rustore img {
            width: 102.88px;
            height: 34.65px;
          }

          &.app-gallery img {
            width: 114.79px;
            height: 34.65px;
          }
        }
      }
    }

    @media screen and (min-width: 768px) {
      gap: 12px;

      .landing-hero-content-left {
        picture.landing-hero-demo {
          padding-top: 0;
        }

        ul.landing-hero-image-description {
          gap: 28px;
          margin-left: -10px;
          padding-top: 38px;

          li {
            background-color: #ffffff;
            border-radius: 10px;
            padding: 10px;
            font-family: Inter, sans-serif;
            font-size: 16px;
            font-weight: 500;
            line-height: 19px;
            text-align: left;
            color: #333333;
            width: fit-content;
            text-wrap: wrap;
            white-space: pre;
          }
        }
      }

      .landing-hero-content-right {
        ul.landing-hero-features {
          li {
            &.landing-hero-gear {
              span {
                max-width: 355px;
              }
              img {
                top: 0;
                left: -24px;
              }
            }

            &.landing-hero-bulb {
              span {
                max-width: 295px;
              }

              img {
                width: 56.03px;
                height: 97.47px;
                top: 5px;
                left: 4px;
              }
            }

            &.landing-hero-darts {
              span {
                max-width: 160px;
              }

              img {
                width: 79.96px;
                height: 74.12px;
                top: -2px;
                left: -15px;
              }
            }
          }
        }

        ul.landing-hero-marketplaces {
          flex-direction: row;
          flex-wrap: wrap;
          gap: 12px;
          max-width: unset;

          li {
            &.google-play img {
              width: 116.95px;
              height: 34.65px;
            }

            &.rustore img {
              width: 102.88px;
              height: 34.65px;
            }

            &.app-gallery img {
              width: 114.79px;
              height: 34.65px;
            }
          }
        }
      }
    }

    @media screen and (min-width: 1000px) {
      display: grid;
      grid-template-columns: 46% 56%;
      //grid-template-rows: 420px;
      gap: 0;

      .landing-hero-content-left {
        padding-right: 35px;
        justify-content: flex-end;
      }

      .landing-hero-content-right {
        align-items: flex-start;
        margin: 0;

        ul.landing-hero-features {
          li {
            &.landing-hero-gear {
              span {
                max-width: 361px;
              }
            }

            &.landing-hero-bulb {
              span {
                max-width: 327px;
              }
              img {
                top: -5px;
                left: 4px;
              }
            }

            &.landing-hero-star {
              padding: 20px 12px 20px 69px;

              span {
                max-width: 205px;
              }

              img {
                width: 82.88px;
                height: 82.29px;
                top: -2px;
                left: -19px;
              }
            }

            &.landing-hero-darts {
              padding: 22px 12px 22px 69px;

              img {
                top: 2px;
                left: -15px;
              }
            }
          }
        }

        ul.landing-hero-marketplaces {
          flex-direction: row;
          flex-wrap: wrap;
          gap: 12px;

          li {
            &.google-play img {
              width: 116.95px;
              height: 34.65px;
            }

            &.rustore img {
              width: 102.88px;
              height: 34.65px;
            }

            &.app-gallery img {
              width: 114.79px;
              height: 34.65px;
            }
          }
        }
      }
    }

    @media screen and (min-width: 1300px) {
      grid-template-columns: 58% 42%;
      //grid-template-rows: 778px;

      .landing-hero-content-left {
        padding-right: 70px;

        ul.landing-hero-image-description {
          gap: 76px;
          padding-top: 66px;

          li {
            padding: 15px;
            border-radius: 20px;
            font-size: 20px;
            font-weight: 500;
            line-height: 24px;
          }

          li:not(:first-child) {
            min-height: 78px;
          }
        }
      }

      .landing-hero-content-right {
        gap: 49px;

        ul.landing-hero-features {
          gap: 28px;

          li {
            font-size: 24px;
            font-weight: 600;
            line-height: 29px;
            padding: 20px 12px 20px 98px;

            &.landing-hero-gear {
              span {
                max-width: 395px;
              }
              img {
                width: 134px;
                height: 129.38px;
                top: 13px;
                left: -42px;
              }
            }

            &.landing-hero-bulb {
              padding: 27px 12px 27px 118px;

              span {
                max-width: 384px;
              }

              img {
                width: 86px;
                height: 149.6px;
                top: -4px;
                left: 0;
              }
            }

            &.landing-hero-star {
              padding: 38px 12px 38px 98px;

              span {
                max-width: 312px;
              }

              img {
                width: 139.99px;
                height: 139px;
                top: -3px;
                left: -46px;
              }
            }

            &.landing-hero-darts {
              padding: 40px 12px 40px 98px;

              span {
                max-width: 239px;
              }

              img {
                width: 133px;
                height: 123.29px;
                top: 7px;
                left: -40px;
              }
            }
          }
        }

        ul.landing-hero-marketplaces {
          gap: 10px;

          li {
            &.google-play img {
              width: 173.61px;
              height: 51.44px;
            }

            &.rustore img {
              width: 152.58px;
              height: 51.48px;
            }

            &.app-gallery img {
              width: 170.4px;
              height: 51.44px;
            }
          }
        }
      }
    }

    @media screen and (min-width: 1690px) {
      display: grid;
      grid-template-columns: 47% 53%;
      //grid-template-rows: 816px;

      .landing-hero-content-left {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        padding-right: 49px;

        ul.landing-hero-image-description {
          gap: 64px;
          padding-top: 56px;
          margin: 0;

          li {
            background-color: #ffffff;
            border-radius: 20px;
            padding: 20px;
            font-family: Inter, sans-serif;
            font-size: 24px;
            font-weight: 500;
            line-height: 29px;
            text-align: left;
            color: #333333;
            width: fit-content;
            text-wrap: wrap;
            white-space: pre;
          }

          li:not(:first-child) {
            min-height: 98px;
          }
        }
      }

      .landing-hero-content-right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 37px;

        ul.landing-hero-features {
          gap: 44px;
          align-items: flex-start;
          justify-content: flex-start;

          li {
            position: relative;
            background-color: #ffffff;
            color: #7b4ef8;
            border-radius: 24px;
            padding: 21px 20px 21px 118px;
            font-size: 27px;
            line-height: 33px;
            text-align: left;

            img {
              position: absolute;
            }

            &.landing-hero-gear {
              span {
                max-width: 599px;
              }

              img {
                width: 145px;
                height: 140px;
                top: 1px;
                left: -40px;
              }
            }

            &.landing-hero-bulb {
              span {
                max-width: 550px;
              }

              img {
                width: 96px;
                height: 167px;
                top: -8px;
                left: 7px;
              }
            }

            &.landing-hero-star {
              padding: 34px 20px 34px 118px;

              span {
                max-width: 350px;
              }

              img {
                width: 142px;
                height: 141px;
                top: -4px;
                left: -32px;
              }
            }

            &.landing-hero-darts {
              padding: 34px 20px 34px 118px;

              span {
                max-width: 269px;
              }

              img {
                width: 137px;
                height: 127px;
                top: 5px;
                left: -26px;
              }
            }
          }
        }

        ul.landing-hero-marketplaces {
          flex-direction: row;
          gap: 44px;

          li {
            &.google-play img {
              width: 216px;
              height: 64px;
            }

            &.rustore img {
              width: 190px;
              height: 64px;
            }

            &.app-gallery img {
              width: 212px;
              height: 64px;
            }
          }
        }
      }
    }

    @media screen and (min-width: 1920px) {
      display: grid;
      grid-template-columns: 47% 53%;
      //grid-template-rows: 816px;

      .landing-hero-content-left {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        padding-right: 49px;

        ul.landing-hero-image-description {
          gap: 64px;
          padding-top: 72px;
          margin: 0;

          li {
            background-color: #ffffff;
            border-radius: 20px;
            padding: 20px;
            font-family: Inter, sans-serif;
            font-size: 24px;
            font-weight: 500;
            line-height: 29px;
            text-align: left;
            color: #333333;
            width: fit-content;
            text-wrap: wrap;
            white-space: pre;
          }
        }
      }

      .landing-hero-content-right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 37px;

        ul.landing-hero-features {
          gap: 44px;
          align-items: flex-start;
          justify-content: flex-start;

          li {
            position: relative;
            background-color: #ffffff;
            color: #7b4ef8;
            border-radius: 24px;
            padding: 21px 20px 21px 118px;
            font-size: 27px;
            line-height: 33px;
            text-align: left;

            img {
              position: absolute;
            }

            &.landing-hero-gear {
              span {
                max-width: 599px;
              }

              img {
                width: 145px;
                height: 140px;
                top: 1px;
                left: -40px;
              }
            }

            &.landing-hero-bulb {
              span {
                max-width: 550px;
              }

              img {
                width: 96px;
                height: 167px;
                top: -8px;
                left: -7px;
              }
            }

            &.landing-hero-star {
              padding: 34px 20px 34px 118px;

              span {
                max-width: 350px;
              }

              img {
                width: 142px;
                height: 141px;
                top: -4px;
                left: -32px;
              }
            }

            &.landing-hero-darts {
              padding: 34px 20px 34px 118px;

              span {
                max-width: 269px;
              }

              img {
                width: 137px;
                height: 127px;
                top: 5px;
                left: -26px;
              }
            }
          }
        }

        ul.landing-hero-marketplaces {
          flex-direction: row;
          gap: 44px;

          li {
            &.google-play img {
              width: 216px;
              height: 64px;
            }

            &.rustore img {
              width: 190px;
              height: 64px;
            }

            &.app-gallery img {
              width: 212px;
              height: 64px;
            }
          }
        }
      }
    }
  }

  .landing-hero-features {
    li {
      align-content: center;
    }
  }

  .landing-hero-gear {
    min-height: 119px;

    @media screen and (min-width: 768px) {
      min-height: 83px;
    }

    @media screen and (min-width: 1000px) {
    }

    @media screen and (min-width: 1300px) {
      min-height: 156px;
    }

    @media screen and (min-width: 1690px) {
      min-height: 172px;
    }

    @media screen and (min-width: 1920px) {
      min-height: 141px;
    }
  }

  .landing-hero-bulb {
    min-height: 100px;

    @media screen and (min-width: 768px) {
      min-height: 83px;
    }

    @media screen and (min-width: 1000px) {
    }

    @media screen and (min-width: 1300px) {
      min-height: 141px;
    }
  }

  .landing-hero-star {
    min-height: 79px;

    @media screen and (min-width: 1300px) {
      min-height: 133px;
    }
  }

  .landing-hero-darts {
    min-height: 81px;

    @media screen and (min-width: 768px) {
      min-height: 83px;
    }

    @media screen and (min-width: 1000px) {
    }

    @media screen and (min-width: 1300px) {
      min-height: 137px;
    }
  }
`;
